module.exports = __webpack_public_path__ + "img/proyectos1.970b3de9.png";